import WidgetsMgr from 'widgets/widgetsMgr';

const hasContexts = (contexts: Array<string>) => contexts.every(context => window.contexts.includes(context));

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout', 'hubbox']),
    load: () =>
        Promise.all([
            import('./widgets/checkout/HubBoxMixin').then(d => d.default),
            import('./widgets/checkout/HubBoxTracking').then(d => d.default)
        ]).then(deps => {
            const [HubBoxMixin, HubBoxTracking] = deps;

            return {
                listId: 'checkout.hubbox',
                widgetsDefinition: () => [
                    ['hubboxPickupPointForm', HubBoxMixin, 'pickupPointForm'],
                    ['hubboxPickupPointForm', HubBoxTracking, 'hubboxPickupPointForm']
                ]
            };
        })
});
